import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const validUpiId = createAsyncThunk(
  "upiStatus/validUpiId",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/platform/vpa-validation`,
        payload
      );
      return response.data;
    } catch (error) {
      if (error?.response) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

const initialState = {
  showUpiVpaTimer: false,
  showUpiVpaError: false,
  upiVpa: "",
  upiVpaError: "",
  upiIntentName: "",
  upiButtonId: "",
  upiType: "",

  validUpiIdLoading: false,
  validUpiIdData: [],
  validUpiIdErrorMessage: '',
};

export const upiStatusSlice = createSlice({
  name: "upiStatus",
  initialState,
  reducers: {
    toggleUpiVpaTimer(state, action) {
      state.showUpiVpaTimer = action.payload;
    },
    toggleUpiVpaError(state) {
      state.showUpiVpaError = !state.showUpiVpaError;
    },
    handleIdForButton(state, action) {
      state.upiButtonId = action.payload;
    },
    changeUpiVpa(state, action) {
      state.upiVpa = action.payload;
    },
    handleUpiError(state, action) {
      state.upiVpaError = action.payload;
    },
    handleIntentAppName(state, action) {
      state.upiIntentName = action.payload;
    },
    setUpiType(state, action) {
      state.upiType = action.payload;
    },
    resetUpiStatus(state) {
      state.validUpiIdData = [];
      state.validUpiIdErrorMessage = "";
      state.validUpiIdLoading = false;
    },
    resetUpiFields(state) {
      state.upiVpa = "";
      state.upiVpaError = "";
    },
    setVpaValidationDetails(state, action) {
      state.validUpiIdLoading = false;
      state.validUpiIdData = action.payload.data;
      state.validUpiIdErrorMessage = action.payload.error;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(validUpiId.pending, (state) => {
        state.validUpiIdLoading = true;
        state.validUpiIdData = [];
        state.validUpiIdErrorMessage = "";
      })
      .addCase(validUpiId.fulfilled, (state, action) => {
        state.validUpiIdLoading = false;
        state.validUpiIdData = action.payload;
        state.validUpiIdErrorMessage = "";
      })
      .addCase(validUpiId.rejected, (state, action) => {
        state.validUpiIdLoading = false;
        state.validUpiIdErrorMessage = action.payload;
      });
  },
});

export const {
  toggleUpiVpaTimer,
  toggleUpiVpaError,
  changeUpiVpa,
  handleIdForButton,
  setSavedUpi,
  handleUpiError,
  handleIntentAppName,
  setUpiType,
  resetUpiStatus,
  resetUpiFields,
  setVpaValidationDetails,
} = upiStatusSlice.actions;

export const selectShowUpiVpaTimer = (state) => state.upiStatus.showUpiVpaTimer;
export const selectShowUpiVpaError = (state) => state.upiStatus.showUpiVpaError;
export const selectUpiButtonId = (state) => state.upiStatus.upiButtonId;
export const selectUpiVpa = (state) => state.upiStatus.upiVpa;
export const vpaError = (state) => state.upiStatus.upiVpaError;
export const intentAppName = (state) => state.upiStatus.upiIntentName;
export const selectUpiType = (state) => state.upiStatus.upiType;

export default upiStatusSlice.reducer;


